if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      
      // Add click event listeners to buttons
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );

      // Add change event to input directly
      if (this.input) {
        this.input.addEventListener('change', () => {
          // Trigger cart update or other necessary actions
          if (this.input.form) {
            const event = new CustomEvent('quantity-update', {
              bubbles: true,
              detail: { quantity: this.input.value }
            });
            this.input.form.dispatchEvent(event);
          }
        });
      }
    }

    // Handle button clicks (plus/minus buttons)
    onButtonClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      
      // Get the current quantity value
      const input = this.querySelector('input');
      const currentValue = parseInt(input.value);
      
      // Check if it's plus or minus button
      const isPlus = button.name === 'plus' || button.classList.contains('plus');
      
      // Calculate new value (minimum value is 1)
      const newValue = isPlus ? currentValue + 1 : Math.max(currentValue - 1, 1);
      
      // Update input value and trigger change event
      input.value = newValue;
      input.dispatchEvent(this.changeEvent);
    }
  });
}